const prefix = "LEVY_ESTIMATOR_";

export const PLAYGROUND_CALCULATE_FAILED = prefix + "PLAYGROUND_CALCULATE_FAILED";
export const PLAYGROUND_CALCULATE_STARTED = prefix + "PLAYGROUND_CALCULATE_STARTED";
export const PLAYGROUND_CALCULATE_SUCCEEDED = prefix + "PLAYGROUND_CALCULATE_SUCCEEDED";
export const PLAYGROUND_EDIT_APPLY = prefix + "PLAYGROUND_EDIT_APPLY";
export const PLAYGROUND_EDIT_QUIT = prefix + "PLAYGROUND_EDIT_QUIT";
export const PLAYGROUND_EDIT_RESET = prefix + "PLAYGROUND_EDIT_RESET";
export const PLAYGROUND_EDIT_START = prefix + "PLAYGROUND_EDIT_START";
export const PLAYGROUND_EDIT_UPDATE = prefix + "PLAYGROUND_EDIT_UPDATE";
export const PUBLIC_ESTIMATOR_CALCULATE_FAILED = prefix + "PUBLIC_ESTIMATOR_CALCULATE_FAILED";
export const PUBLIC_ESTIMATOR_CALCULATE_STARTED = prefix + "PUBLIC_ESTIMATOR_CALCULATE_STARTED";
export const PUBLIC_ESTIMATOR_CALCULATE_SUCCEEDED = prefix + "PUBLIC_ESTIMATOR_CALCULATE_SUCCEEDED";
export const PUBLIC_ESTIMATOR_GET_FAILED = prefix + "PUBLIC_ESTIMATOR_GET_FAILED";
export const PUBLIC_ESTIMATOR_GET_STARTED = prefix + "PUBLIC_ESTIMATOR_GET_STARTED";
export const PUBLIC_ESTIMATOR_GET_SUCCEEDED = prefix + "PUBLIC_ESTIMATOR_GET_SUCCEEDED";
export const PUBLIC_ESTIMATOR_UPDATE = prefix + "PUBLIC_ESTIMATOR_UPDATE";
export const STATE_RESET = prefix + "STATE_RESET";
export const STATE_UNLOAD = prefix + "STATE_UNLOAD";
export const VIEW_FAILED = prefix + "VIEW_FAILED";
export const VIEW_STARTED = prefix + "VIEW_STARTED";
export const VIEW_SUCCEEDED = prefix + "VIEW_SUCCEEDED";
